import { FiMessageSquare } from 'react-icons/fi';

const ALL_PANEL_ROLES = [
  'admin',
  'superAdmin',
  'financeManager',
  'complianceOfficer',
  'marketingSpecialist',
  'supportAgent'
];

const messages = {
  id: 'messages',
  title: '',
  type: 'group',
  children: [
    {
      id: 'messages-management',
      title: 'Messages',
      type: 'item',
      url: '/messages',
      icon: FiMessageSquare,
      allowedRoles: ALL_PANEL_ROLES,
      breadcrumbs: false
    }
  ]
};

export default messages;
